import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12c22ed0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "restore" }
const _hoisted_2 = { class: "restore-head" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "cloud" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "从云备份空间恢复数据", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "restore-content" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "1. 请将保证设备网络连接畅通。")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", null, "2. 在恢复备份数据过程中，保持设备供电正常。")
  ])
], -1))
const _hoisted_6 = { class: "btns" }
const _hoisted_7 = {
  key: 0,
  class: "error-message"
}
const _hoisted_8 = {
  key: 0,
  class: "pop"
}
const _hoisted_9 = { class: "pop-content" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [
  /*#__PURE__*/_createElementVNode("i"),
  /*#__PURE__*/_createTextVNode(" 确定暂不恢复备份数据吗？")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "备份数据不恢复至内置磁盘，将不能对已备份文件进行删除、编辑、查看等操作。剩余云备份空间容量，仍可以继续备份使用。", -1))

import { ref, watchEffect } from 'vue'
import { turnOnRestoreService } from '@remote/api/adapter/shell-mqtt'
import { toast } from '@remote/utils/dialog'
import { checkState } from '@remote/store/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
    close: null,
    capacity: null,
    abandonRestore: { type: Boolean },
    gotoResultPreCallback: null,
    gotoResult: null
  },
  setup(__props: any) {

const props = __props as {
  close: () => void
  capacity: 'y' | 'n'
  abandonRestore?:boolean
  gotoResultPreCallback?: () => void
  gotoResult: () => void
}



const isAbandonRestore = ref(false)

watchEffect(() => {
  isAbandonRestore.value = !!props.abandonRestore
})

const errorMessage = ref('')

const handleAbandonRestore = () => {
  isAbandonRestore.value = true
}

const handleRestore = () => {
  const checkStateRet = checkState()
  if (checkStateRet) {
    errorMessage.value = checkStateRet
    return
  }
  // 磁盘容量不足
  if (props.capacity === 'n') {
    props.gotoResultPreCallback && props.gotoResultPreCallback()
    props.gotoResult()
  } else {
    // 开启恢复
    turnOnRestoreService()
      .then(res => {
        toast({
          message: '备份正在恢复中...',
          type: 'loading',
        })
        props.close()
      })
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("i", {
          class: "icomoon-close head-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.close && props.close(...args)))
        })
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", { onClick: handleRestore }, "立即恢复"),
        _createElementVNode("span", { onClick: handleAbandonRestore }, "暂不恢复"),
        (errorMessage.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (isAbandonRestore.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _hoisted_11,
            _createElementVNode("div", null, [
              _createElementVNode("span", { onClick: handleRestore }, "立即恢复"),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (props.close && props.close(...args)))
              }, "暂不恢复")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})